import React from 'react'
import { Box, BoxProps } from '@mui/material'
import Span from '../span/Span'

interface Props extends Omit<BoxProps, 'onChange' | 'ref'> {
  checked: boolean
  onChange?: (val: boolean) => void
  labels: [string, string]
}

const OptionSwitch = React.forwardRef(
  ({ checked, onChange, sx, labels, ...restProps }: Props, ref) => {
    const handleClick = () => {
      onChange?.(!checked)
    }

    return (
      <Box
        sx={{
          background: 'lightgray',
          height: '2.5rem',
          display: 'inline-grid',
          gridTemplateColumns: '1fr 1fr',
          alignItems: 'center',
          padding: '.5rem',
          borderRadius: '.5rem',
          columnGap: '1rem',
          position: 'relative',
          border: '2px solid lightgray',
          overflow: 'hidden',
          cursor: 'pointer',
          userSelect: 'none',
          textAlign: 'center',
          '& > *': {
            fontSize: '.9rem'
          },
          ...sx
        }}
        onClick={handleClick}
        ref={ref}
        {...restProps}
      >
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            height: '100%',
            width: '50%',
            background: 'white',
            ...(checked
              ? {
                  left: '50%'
                }
              : {
                  left: 0
                }),
            transition: 'left .1s'
          }}
        />
        <Span>{labels[0]}</Span>
        <Span>{labels[1]}</Span>
      </Box>
    )
  }
)
export default OptionSwitch
